import {
  createContext,
  Dispatch,
  PropsWithChildren,
  ReactElement,
  SetStateAction,
  useState,
} from 'react';
import { GeofenceProperties } from '@casops/store/apis/geofencesApi';

export const GeofenceTooltipGetterContext = createContext<GeofenceProperties | undefined>(
  undefined,
);

export const GeofenceTooltipSetterContext = createContext<
  Dispatch<SetStateAction<GeofenceProperties | undefined>> | undefined
>(undefined);

export const GeofenceTooltipContextProvider = ({ children }: PropsWithChildren): ReactElement => {
  const [tooltipProperties, setTooltipProperties] = useState<GeofenceProperties | undefined>(
    undefined,
  );

  return (
    <GeofenceTooltipSetterContext.Provider value={setTooltipProperties}>
      <GeofenceTooltipGetterContext.Provider value={tooltipProperties}>
        {children}
      </GeofenceTooltipGetterContext.Provider>
    </GeofenceTooltipSetterContext.Provider>
  );
};
